import PropTypes from 'prop-types';
import { TableCell, Typography } from '@mui/material';

import { componentsSize, SORTABLE_TABLE_COLUMN_TYPES } from 'constants/components';
import { ActionsMenu, IconsActions, Label, ReportLink, TitleTooltip } from 'components/simple';

const getCellStyles = ({ palette, spacing }) => ({
  padding: spacing(3),
  backgroundColor: palette.colors.lightPale,
  borderBlock: `2px solid ${palette.colors.darkPale}`,

  '&:first-of-type': {
    borderRadius: '20px 0 0 20px',
    borderLeft: `2px solid ${palette.colors.darkPale}`,
  },

  '&:last-of-type': {
    borderRadius: '0 20px 20px 0',
    borderRight: `2px solid ${palette.colors.darkPale}`,
  },
});

const SortableTableCell = ({
  cellData: { columnType, align = 'left', value = null, nameLength = 0 },
  onLabelClick = null,
}) => (
  <TableCell align={align} sx={getCellStyles}>
    {columnType === SORTABLE_TABLE_COLUMN_TYPES.NAME && (
      <TitleTooltip titleLength={nameLength} title={value} variant="subtitle1-bold" component="span" display="block" />
    )}

    {columnType === SORTABLE_TABLE_COLUMN_TYPES.TEXT && (
      <Typography variant="subtitle1" component="span">
        {value}
      </Typography>
    )}

    {columnType === SORTABLE_TABLE_COLUMN_TYPES.LABEL && value && <Label labelType={value} />}

    {columnType === SORTABLE_TABLE_COLUMN_TYPES.REPORT_LINK && value && <ReportLink onClick={onLabelClick} />}

    {columnType === SORTABLE_TABLE_COLUMN_TYPES.ACTIONS_MENU && <ActionsMenu options={value} />}

    {columnType === SORTABLE_TABLE_COLUMN_TYPES.ICONS_ACTIONS && (
      <IconsActions actions={value} size={componentsSize.small} />
    )}
  </TableCell>
);

SortableTableCell.propTypes = {
  onLabelClick: PropTypes.func,
  cellData: PropTypes.shape({
    dataKey: PropTypes.string.isRequired,
    columnType: PropTypes.oneOf(Object.values(SORTABLE_TABLE_COLUMN_TYPES)).isRequired,
    align: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array]),
    nameLength: PropTypes.number,
  }).isRequired,
};
export default SortableTableCell;
